export const appInfoSpecialitiesSelector = (state) =>
    state.appInfo.specialities;
export const appInfoCountriesSelector = (state) => state.appInfo?.countries;
export const appInfoSelector = (state) => state.appInfo;
